export default __webpack_public_path__ + "static/media/homebanner3.d30677a3.jpg";